import http from '../request'
export async function school() {
  return http.get('/mobile/school')
}
export async function classroom(data) {
  return http.get('mobile/classroom', {
    params: data
  })
}
